module.exports = __webpack_public_path__ + "img/image-implantation-14.e8c5b09d.png";